import {inlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

export class GetFinancingDataAdsService extends Service {
  constructor({repository}) {
    super()

    this._repository = repository
  }

  /**
   * @param {String} adId
   * @return {Promise<FinancingDataVO, Error>}
   */
  @inlineError
  async execute({adId, entry = null, terms = null}) {
    const [getFinancingDataError, getFinancingDataResponse] = await this._repository.getFinancingData({
      adId,
      entry,
      terms
    })

    return getFinancingDataError ? Promise.reject(getFinancingDataError) : getFinancingDataResponse
  }
}
